import React from 'react';
import {useHistory} from "react-router-dom";
import {useDispatchMall} from "../../../hooks";
import useWindowDimensions from "../../../hooks/useWindowDimensions";

function convertTypeToRoute(type){
    switch(type){
        case 'home':
            return "/home"
            break;
        case 'services':
            return "/services"
            break;
        case 'store':
            return "/store"
            break;
        case 'blogpost':
            return "/blogs"
            break;
        case 'rewards':
            return "/reward"
            break;
        default:
            return "/home"
    }
}

function SeeMore ({merchant,link=null,destination=null}){
    const history = useHistory()
    const setMall = useDispatchMall();

    const { height, width,mobileWidth } = useWindowDimensions();

    const goToLink = (link)=>{
        window.open(link, "_blank")
    }

    const goTo = (type)=>{
        let route = convertTypeToRoute(type)
        localStorage.setItem('mallId',merchant.mall.uid);
        localStorage.setItem('mallLogo',merchant.mall.header_image);
        localStorage.setItem('mallWhite',merchant.mall.logo);
        localStorage.setItem('mallName',merchant.mall.name);
        localStorage.setItem('mall',JSON.stringify(merchant.mall));
        setMall(merchant.mall);
        history.push(route)
    }

    return(
        <div className="top-float-send-btn" style={{width:mobileWidth?mobileWidth:document?.getElementById('mobile-sec')?.clientWidth}}>

            <div className="float-btn"  onClick={()=>{
                if(destination)
                    goTo(destination)

                if(link)
                    goToLink(link)
            }}>
                <i className="fa fa-angle-left"></i>
                <span>{merchant.see_more?merchant.see_more:"ورود به اپلیکیشن"}</span>
            </div>
        </div>
    )
}
export default SeeMore;
